// extracted by mini-css-extract-plugin
export var externalLink = "_8k-0";
export var internalLinkLabel = "_8k-1";